import { cn } from '@/lib/utils'
import type { NavigationIcon } from './navigation-config'

/**
 * Standardized icon component for section headers and navigation items.
 * Maintains consistent styling across the app (app-topbar, title-section, profile-selector-popover, etc.)
 */
export function SectionIcon(props: { icon: NavigationIcon; className?: string }) {
  const Icon = props.icon
  return <Icon className={cn('h-4 w-4', props.className)} />
}
